import { useCallback, useMemo } from "react";
import { times } from "lodash";
import { Post } from "@radarly/models/posts";

export default function useTopPosts(
  posts: Post[],
  limit: number,
  isFullscreen: boolean,
  closeFullscreen: () => void
) {
  const postsList: Post[] & { isPhantom?: boolean } = useMemo(() => {
    const upperMultiple = limit * Math.ceil(posts.length / limit);
    const missingRowsCount = upperMultiple - posts.length;
    if (!missingRowsCount) {
      return posts;
    }
    return [
      ...posts,
      ...times(missingRowsCount, () => ({
        ...posts[0],
        isPhantom: true,
      })),
    ];
  }, [posts, limit]);

  const onClickPost = useCallback(
    (event: React.MouseEvent, url: string) => {
      if (isFullscreen) {
        closeFullscreen();
      }
      event.stopPropagation();
      window.open(url, "_blank");
    },
    [isFullscreen, closeFullscreen]
  );

  return {
    postsList,
    paginationTotal: posts.length,
    onClickPost,
  };
}
